import * as React from "react";
import {
    DataTable,
    DataTableHeader,
    DataTableHeaderColumn,
    DataTableBody,
    DataTableToolsRow,
    DataTableRow,
    DataTableRowColumn,
    DataTableFooter,
    DataTableFooterColumn,
} from "../DataTable";
import { ListItem } from "material-ui";
import PagingBaseComponent from "components/PagingBaseComponent";
import {
    PagingBaseProps,
    PagingBaseState,
    Page,
    HasId,
} from "components/PagingBaseComponent";
import { Redirect } from "react-router-dom";
import styles = require("./style.less");
import BusyIndicator from "components/BusyIndicator/BusyIndicator";
import * as cn from "classnames";
import {getNavigationUrl} from "../PagingBaseComponent/PagingBaseComponent";

interface PagingDataTableProps<R extends HasId> extends PagingBaseProps<R> {
    onToolsSection?: any;
    headerColumns: any[];
    headerColumnClassNames?: string[];
    rowColumnClassName?: string;
    onEmpty?: any;
}

// tslint:disable-next-line:no-empty-interface
interface PagingDataTableState<R extends HasId> extends PagingBaseState<R> {
}

export abstract class PagingDataTable<R extends HasId> extends PagingBaseComponent<R, PagingDataTableProps<R>, PagingDataTableState<R>> {
    private empty: React.ReactNode = (<div>No results</div>);

    constructor(props: any) {
        super(props);
        this.empty = props.empty || this.empty;
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo} push={true} />;
        }
        if (!this.state.data) {
            return <BusyIndicator show={true} />;
        }

        const {
            onToolsSection,
            headerColumns,
            headerColumnClassNames,
            rowColumnClassName,
            onRow,
            onEmpty,
        } = this.props;

        const data = this.state.data;
        const thereIsData = data && data.Items && data.Items.length > 0;

        return (
            <DataTable>
                <DataTableHeader>
                    {(this.props.filterSearchEnabled || onToolsSection) &&
                    <DataTableToolsRow>
                        <DataTableHeaderColumn
                        colSpan={headerColumns.length}>
                            {this.renderFilterSearchComponents()}
                            {onToolsSection && onToolsSection()}
                        </DataTableHeaderColumn>
                    </DataTableToolsRow>}
                    {thereIsData
                    ? this.buildTableHeader(headerColumns, headerColumnClassNames)
                    : null}
                </DataTableHeader>
                <DataTableBody>
                {
                    thereIsData
                    ? data.Items.filter((item: any) => this.onFilter(this.state.filter, item))
                        .map((item: any, index: number) => this.buildTableRow(item, index, onRow(item), rowColumnClassName))
                    : <DataTableRow displayNoBorder={true}>
                        <DataTableRowColumn>
                            {onEmpty ? onEmpty() : null}
                        </DataTableRowColumn>
                    </DataTableRow>
                }
                </DataTableBody>
                {
                thereIsData && data.Items.length < this.state.data.TotalResults
                    ? <DataTableFooter>
                        <DataTableToolsRow>
                            <DataTableFooterColumn colSpan={headerColumns.length}>
                                {this.props.showPagingInNumberedStyle
                                    ? this.showPagingInNumberedStyle()
                                    : this.showPagingInLoadMoreStyle()}
                            </DataTableFooterColumn>
                        </DataTableToolsRow>
                        </DataTableFooter>
                    : null
                }
            </DataTable>
        );
    }

    // DataTable helpers

    private buildTableHeader(headerColumns: any[], columnClassNames: string[]) {
        return (
            <DataTableRow>
                {headerColumns.map((col, index) => {
                    const props: any = {
                        key: index
                    };

                    if (columnClassNames) {
                        const className = columnClassNames[index];
                        props["className"] = className;
                    }

                    return (
                        <DataTableHeaderColumn {...props}>
                            {col}
                        </DataTableHeaderColumn>
                    );
                })}
            </DataTableRow>
        );
    }

    private buildTableRow(item: R, index: number, rowColumns: any, className: string) {
        // Only some tables include a redirect, so only show cursor if necessary.
        const redirectUrl = getNavigationUrl(this.props, item);
        const linkClassName = redirectUrl ? styles.linkableItem : null;
        return (
            <DataTableRow key={index} onClick={(e: any) => this.navigate(item)}>
                {rowColumns.map((col: any, idx: number) => {
                    const props: any = {
                        key: idx
                    };
                    if (className) {
                        props["className"] = cn(className, props["className"]);
                    }
                    if (linkClassName) {
                        props["className"] = cn(linkClassName, props["className"]);
                    }
                    return (
                        <DataTableRowColumn {...props}>
                            {col}
                        </DataTableRowColumn>
                    );
                })}
            </DataTableRow>
        );
    }
}

(PagingDataTable as any).defaultProps = {
    showFilterWithinSection: false,
    autoFocusOnFilterSearch: true
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PagingDataTable/PagingDataTable.tsx